import { useTranslation } from "react-i18next";

import type { OrderQuery } from "~/graphql/graphql-new.gen";
import { formatRange } from "~/utils/date";

export type EstimatedDeliveryDatesProps = {
  estimatedDeliveryDateRange?: OrderQuery["order"]["parcels"][number]["estimatedDeliveryDateRange"];
  history?: OrderQuery["order"]["shipping"]["deliveryDateRangeHistory"];
};

export const EstimatedDeliveryDates: React.FC<EstimatedDeliveryDatesProps> = ({
  estimatedDeliveryDateRange,
  history,
}: EstimatedDeliveryDatesProps) => {
  const { i18n } = useTranslation();

  if (!history) return null;

  const firstEstimatedDeliveryDate =
    history.length > 0 ? history[history.length - 1] : null;

  const lastEstimatedDeliveryDate = estimatedDeliveryDateRange
    ? {
        start: estimatedDeliveryDateRange.min,
        end: estimatedDeliveryDateRange.max,
      }
    : history.length > 1
      ? history[0]
      : null;

  return (
    <>
      {lastEstimatedDeliveryDate ? (
        <span className="font-bold">
          {formatRange(
            new Date(lastEstimatedDeliveryDate.start),
            new Date(lastEstimatedDeliveryDate.end),
            i18n.language.replace("_", "-"),
          )}
        </span>
      ) : null}{" "}
      {firstEstimatedDeliveryDate ? (
        <span
          className={lastEstimatedDeliveryDate ? "line-through" : "font-bold"}
        >
          {formatRange(
            new Date(firstEstimatedDeliveryDate.start),
            new Date(firstEstimatedDeliveryDate.end),
            i18n.language.replace("_", "-"),
          )}
        </span>
      ) : null}
    </>
  );
};
